import { useQuery } from '@apollo/react-hooks';

import { toQuizFeedReportVariables } from 'Domains/adaptiveQuiz';
import { useLessonName } from 'Domains/AttendanceFilterData';
import { SYLLABUS_MODE } from 'Domains/syllabus';
import { getQuizFeedReport } from 'GraphQL/queries/report.query';

const QuizFeedReportData = ({ value, schoolCode, children }) => {
  const { term, grade, classNo, subject, syllabus, lesson, mode } = value;
  const { isLessonSelected, lessonName } = useLessonName(value, schoolCode);

  const isSkip =
    !term ||
    !grade ||
    !classNo ||
    !subject ||
    !syllabus ||
    !lesson ||
    // wait for the name of the selected lesson, because quiz feed tables are filtered by its name
    (isLessonSelected && !lessonName) ||
    !schoolCode ||
    mode !== SYLLABUS_MODE.TUNGKAI;

  const { loading, error, data, refetch, networkStatus } = useQuery(getQuizFeedReport, {
    variables: { ...toQuizFeedReportVariables({ ...value, lessonName }), schoolCode },
    skip: isSkip,
    notifyOnNetworkStatusChange: true,
  });

  return children({ loading, error, data, refetch, networkStatus });
};

export default QuizFeedReportData;
